import React, { useState, useEffect } from "react";
import { FaSpinner } from "react-icons/fa";
import { format } from "date-fns";
import toast from "react-hot-toast";
import axios from 'axios';

const CreateNfseModal = ({ isOpen, onClose, onCreated, emitenteId }) => {
    const [clientes, setClientes] = useState([]);
    const [servicos, setServicos] = useState([]);
    const [ufs, setUfs] = useState([]);
    const [cidades, setCidades] = useState([]);

    const [clienteSelecionado, setClienteSelecionado] = useState("");
    const [servicoSelecionado, setServicoSelecionado] = useState("");
    const [ufSelecionado, setUfSelecionado] = useState("");
    const [cidadeSelecionada, setCidadeSelecionada] = useState("");
    const [valor, setValor] = useState("");
    const [mensagem, setMensagem] = useState("");
    const [data, setData] = useState(new Date());

    const [loading, setLoading] = useState(false);

    const URL_BACKEND = process.env.REACT_APP_URL_BACKEND;


    // Carregar estados
    useEffect(() => {
        (async () => {
            try {
                const token = localStorage.getItem("userToken");
                const { data } = await axios.get(`${URL_BACKEND}/estados`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                if (data) setUfs(data);
            } catch (err) {
                toast.error("Erro ao carregar estados.");
            }
        })();
    }, []);

    // Carregar clientes
    useEffect(() => {
        (async () => {
            try {
                setLoading(true);
                const token = localStorage.getItem("userToken");
                if (!token || !emitenteId) return;

                const { data } = await axios.get(`${URL_BACKEND}/clientes/Todos/${emitenteId}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                if (data) setClientes(data);
            } catch (err) {
                toast.error("Erro ao carregar clientes.");
            } finally {
                setLoading(false);
            }
        })();
    }, [emitenteId]);

    // Carregar serviços
    useEffect(() => {
        (async () => {
            try {
                const token = localStorage.getItem("userToken");
                const { data } = await axios.get(`${URL_BACKEND}/servicos`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                if (data) setServicos(data);
            } catch (err) {
                toast.error("Erro ao carregar serviços.");
            }
        })();
    }, []);

    // Carregar cidades ao mudar UF
    useEffect(() => {
        if (!ufSelecionado) return;
        (async () => {
            try {
                const token = localStorage.getItem("userToken");
                const { data } = await axios.get(`${URL_BACKEND}/cidades/${ufSelecionado}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                if (data) setCidades(data);
            } catch (err) {
                toast.error("Erro ao carregar cidades.");
            }
        })();
    }, [ufSelecionado]);

    const handleCreate = async () => {
        if (!clienteSelecionado || !servicoSelecionado || !cidadeSelecionada || !ufSelecionado || !valor) {
            toast.error("Preencha todos os campos obrigatórios.");
            return;
        }

        const token = localStorage.getItem("userToken");

        const payload = {
            id_emitente: emitenteId,
            id_cliente: clienteSelecionado,
            id_servico: servicoSelecionado,
            id_cidade: cidadeSelecionada,
            id_estado: ufSelecionado,
            numero: 123, // pode vir do backend
            valor: parseFloat(valor),
            descricao: mensagem,
            data: format(new Date(data), "yyyy-MM-dd HH:mm:ss"),
            status: "Pendente",
            id_faturamento: 0,
        };

        try {
            toast.loading("Criando NFS-e...", { id: "createNfse" });
            await axios.post(`${URL_BACKEND}/createNfse`, payload, {
                headers: { Authorization: `Bearer ${token}` },
            });
            toast.success("NFS-e criada com sucesso!", { id: "createNfse" });
            onCreated && onCreated();
            onClose();
        } catch (err) {
            console.error(err);
            toast.error(err.response?.data?.message || "Erro ao criar NFS-e.", { id: "createNfse" });
        }
    };

    if (!isOpen) return null;

    return (
        <div style={modalStyles.overlay}>
            <div style={modalStyles.modal}>
                <h2 style={modalStyles.title}>Nova NFS-e</h2>

                {loading ? (
                    <p><FaSpinner className="fa-spin" /> Carregando...</p>
                ) : (
                    <div style={modalStyles.form}>
                        <label>Cliente</label>
                        <select value={clienteSelecionado} onChange={(e) => setClienteSelecionado(e.target.value)} style={modalStyles.input}>
                            <option value="">Selecione...</option>
                            {clientes.map(c => <option key={c.id} value={c.id}>{c.nome}</option>)}
                        </select>

                        <label>Serviço</label>
                        <select
                            value={servicoSelecionado}
                            onChange={(e) => setServicoSelecionado(e.target.value)}
                            style={modalStyles.input}
                        >
                            <option value="">Selecione...</option>
                            {servicos.map(s => (
                                <option key={s.codigo} value={s.id}>
                                    {s.codigo} - {s.descricao}
                                </option>
                            ))}
                        </select>

                        <label>UF</label>
                        <select
                            value={ufSelecionado}
                            onChange={(e) => setUfSelecionado(e.target.value)}
                            style={modalStyles.input}
                        >
                            <option value="">Selecione...</option>
                            {ufs.map((uf) => (
                                <option key={uf.codigo_uf} value={uf.codigo_uf}>
                                    {uf.nome}
                                </option>
                            ))}
                        </select>

                        <label>Cidade</label>
                        <select
                            value={cidadeSelecionada}
                            onChange={(e) => setCidadeSelecionada(e.target.value)}
                            style={modalStyles.input}
                            disabled={!ufSelecionado}
                        >
                            <option value="">Selecione...</option>
                            {cidades.map((c) => (
                                <option key={c.id} value={c.id}>
                                    {c.nome}
                                </option>
                            ))}
                        </select>

                        <label>Valor</label>
                        <input type="number" value={valor} onChange={(e) => setValor(e.target.value)} style={modalStyles.input} />

                        <label>Descrição</label>
                        <input type="text" value={mensagem} onChange={(e) => setMensagem(e.target.value)} style={modalStyles.input} />

                        <label>Data</label>
                        <input type="date" value={format(new Date(data), "yyyy-MM-dd")} onChange={(e) => setData(e.target.value)} style={modalStyles.input} />
                    </div>
                )}

                <div style={modalStyles.actions}>
                    <button onClick={onClose} style={modalStyles.cancel}>Cancelar</button>
                    <button onClick={handleCreate} style={modalStyles.confirm}>Criar</button>
                </div>
            </div>
        </div>
    );
};

const modalStyles = {
    overlay: {
        position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex", justifyContent: "center", alignItems: "center",
        zIndex: 9999,
    },
    modal: {
        backgroundColor: "#fff", borderRadius: 12, padding: 24,
        width: "500px", maxHeight: "90vh", overflowY: "auto",
        boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
    },
    title: { marginBottom: 16 },
    form: { display: "flex", flexDirection: "column", gap: 12 },
    input: {
        padding: "10px 14px",
        border: "1px solid #ddd",
        borderRadius: 8,
    },
    actions: { marginTop: 20, display: "flex", justifyContent: "flex-end", gap: 12 },
    cancel: {
        backgroundColor: "#ccc", border: "none", padding: "10px 16px",
        borderRadius: 8, cursor: "pointer",
    },
    confirm: {
        backgroundColor: "#667eea", color: "#fff", border: "none",
        padding: "10px 16px", borderRadius: 8, cursor: "pointer",
    },
};

export default CreateNfseModal;
